import {useEffect, useState} from 'react'
import {formatMonetaryToBr, removeMask} from '../../utils/formatMonetaryToBr'
import {usePaymentConfig} from './core/PaymentConfigProvider'
import {PageOverlayer} from '../PageOverlayer'
import {SelectPaymentMethod} from './components/SelectPaymentMethod'
import {SplitPayment} from './components/SplitPayment'

interface IPaymentConfig {
  totalPayable: number
  includeOldRecurrence?: boolean
  hideRecurrence?: boolean
  recurrenceMaxInstallments?: number
}
export const PaymentConfig = ({
  totalPayable,
  includeOldRecurrence,
  hideRecurrence,
  recurrenceMaxInstallments,
}: IPaymentConfig) => {
  const {payment} = usePaymentConfig()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let current = payment?.reduce((previousValue, currentValue) => {
      return Number(previousValue) + Number(removeMask(String(currentValue.value)))
    }, 0)
  }, [payment])

  let current = payment?.reduce((previousValue, currentValue) => {
    return Number(previousValue) + Number(removeMask(String(currentValue.value)))
  }, 0)

  return (
    <>
      {loading && <PageOverlayer />}

      <div className='modal-header position-relative mb-7'>
        <div className='text-center w-100 '>
          <h3 className='modal-title fw-bold'>Escolha a forma de pagamento</h3>
        </div>
      </div>

      <div className='row d-flex '>
        <div className='col-md-5 col-12 h-100'>
          <div className='d-flex justify-content-between mb-1'>
            <span className='fw-bold d-block text-danger'>Total a pagar: </span>
            <span className='fw-semi-bold d-block text-danger'>
              {formatMonetaryToBr(totalPayable)}
            </span>
          </div>
          <div className='d-flex justify-content-between mb-8'>
            <span className='fw-bold d-block'>Total a selecionar:</span>
            <span className='fw-semi-bold d-block'>
              {formatMonetaryToBr(Number(totalPayable) - current)}
            </span>
          </div>
          <div className='col-12 ' style={{overflowY: 'auto', overflowX: 'hidden'}}>
            <SplitPayment payment={payment} />
          </div>
        </div>

        <div className='col-md-1 d-flex' style={{alignItems: 'center', justifyContent: 'center'}}>
          <div
            className='border border-left-0 border-top-0 border-bottom-0 border-right-2'
            style={{width: 1, minHeight: 200}}
          ></div>
        </div>
        <div className='col-md-6 col-12 h-100 border-left p-0'>
          <h6 className='mb-2'>Forma de pagamento</h6>
          <div
            className='col-12 '
            style={{maxHeight: '400px', overflowY: 'auto', overflowX: 'hidden'}}
          >
            <SelectPaymentMethod
              includeOldRecurrence={includeOldRecurrence}
              hideRecurrence={hideRecurrence}
              recurrenceMaxInstallments={recurrenceMaxInstallments}
            />
          </div>
        </div>
      </div>
    </>
  )
}
